import {
    QYGL
} from '../constants/funcUrl'

const qyglMutation = {
    [QYGL.LEARNWEIXINPAYCODE](state, data) {
        state.learnWeixinPayCode = data;
    },
    [QYGL.LEARNWEIXINPAYRESULT](state, data) {
        state.learnWeixinPayResult = data;
    },
    [QYGL.ENTERPRISEEMPLOYEE](state, data) {
        state.enterpriseEmployee = data;
    },
    [QYGL.LEARNENTERPRISELEARN](state, data) {
        state.enterpriseApprove = data;
    },
    [QYGL.LEARNINGMGTQY](state, data) {
        state.learningmgtQY = data;
    },
    [QYGL.MAKEUPLEARNDETAILS](state, data) {
        state.makeUpLearnDetails = data;
    },
    [QYGL.MAKEUPENTERPRISEMAKEUP](state, data) {
        state.enterpriseMakeUpApprove = data;
    },
    [QYGL.ENTERPRISEMYENTERPRISE](state, data) {
        state.enterprise = data;
    },
    [QYGL.CMTYPE](state, data) {
        state.cmType = data;
    },
    [QYGL.CMJOB](state, data) {
        state.cmJob = data;
    },
    [QYGL.ALLCMJOB](state, data) {
        state.cmJob = data;
    },
    [QYGL.CMCERTIFICATEQY](state, data) {
        state.cmCertificate = data;
    },
    [QYGL.CMCERTIFICATEDETAILS](state, data) {
        state.cmCertificateDetails = data;
    },
    [QYGL.CMCERTIFICATEREMOTESEARCH](state, data) {
        state.remoteCmCertificate = data;
    },
    [QYGL.CMEMPLOYEE](state, data) {
        state.cmEmployee = data;
    },
    [QYGL.CMEMPLOYEEDETAILS](state, data) {
        state.cmEmployeeDetails = data;
    },
    [QYGL.CMPROJECT](state, data) {
        state.cmProject = data;
    },
    [QYGL.CMPROJECTDETAILS](state, data) {
        state.cmProjectDetails = data;
    },

    [QYGL.INVOICEAPPROVEAPPROVELEARNS](state, data) {
        state.approveLearns = data;
    },
    [QYGL.INVOICEAPPROVESTATES](state, data) {
        state.invoiceApproveStates = data;
    },
    [QYGL.INVOICEAPPROVEQY](state, data) {
        state.invoiceApproves = data;
    },
    [QYGL.INVOICEAPPROVELAST](state, data) {
        state.lastInvoiceApprove = data;
    },

    [QYGL.BDYTESTMGTBATCHEMPLOYEES](state, data) {
        state.bdyTestBatchEmployees = data;
    },
    [QYGL.BDYTESTMGTBATCHADDEMPLOYEES](state, data) {
        state.bdyTestBatchAddEmployees = data;
    },
    [QYGL.BDYTESTMGTSESSIONSELECT](state, data) {
        state.selectBdyTestSessions = data;
    },

    [QYGL.ENTERPRISEMODIFYAPPROVES](state, data) {
        state.enterpriseModifyApproves = data;
    },
    [QYGL.ENTERPRISEMODIFYAPPROVESTATES](state, data) {
        state.enterpriseModifyApproveStates = data;
    },

    [QYGL.BDYPRACTICEENROLLADDEMPLOYEES](state, data) {
        state.bdyPracticeEnrollAddEmployees = data;
    },

    [QYGL.ZJYTESTMGTBATCHADDEMPLOYEES](state, data) {
        state.zjyTestBatchAddEmployees = data;
    }

}

export default qyglMutation;



// WEBPACK FOOTER //
// ./src/store/jzjy/mutations/qyglMutation.js